export namespace LocalStorageConstants {
  export const RIDER_AUTHENTICATION_STATE_KEY = 'uzurvRider.riderAuthenticationState';
  export const RIDER_MOBILITY_PROFILE_NOTIFICATION_DISMISSAL_TIMESTAMP_KEY =
    'uzurvRider.riderMobilityProfileNotificationDismissalTimestamp';
  export const RIDER_LAST_USED_PAYMENT_ACCOUNT_ID_KEY = 'uzurvRider.lastUsedPaymentAccountId';
}
